"use strict";
import { addBrowserClasses } from "./modules/_utils";
// import "./modules/_nav";
import "./modules/_nav-main";
import "./modules/_resizeTimer";
import "./modules/_job-search";
import { scrollTrigger } from "./modules/_scroll";
import "./modules/_glide";
import "./modules/_faq-accordion";
import { tabsWithContent } from "./modules/_tabs";
import { initAcc, job_detail_accordion } from "./modules/_accordion";

document.addEventListener("DOMContentLoaded", function () {
  // console.log("default script.js is loading");

  if (document.getElementsByClassName("no-js")[0]) {
    document.getElementsByClassName("no-js")[0].classList.remove("no-js");
  }

  // Common functions
  addBrowserClasses();

  // Import Javascript modules here:
  // example_module();
  initAcc(".tab-content", false);

  // Job Details Page accordion
  if (document.querySelector(".tab-list")) {
    job_detail_accordion();
  } // if tablist

  // Homepage hero button
  const mq = window.matchMedia("screen and (min-width: 1025px)");
  const heroBtn = document.getElementById("search-jobs");

  if (heroBtn) {
    if (window.innerWidth > 1024) {
      heroBtn.classList.add("primary");
    } else {
      heroBtn.classList.add("secondary");
    }

    mq.addEventListener("change", (event) => {
      if (event.matches) {
        heroBtn.classList.add("primary");
        heroBtn.classList.remove("secondary");
      } else {
        heroBtn.classList.add("secondary");
        heroBtn.classList.remove("primary");
      }
    });
  }

  // Lazy load css background images
  let lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy"));

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function (
      entries,
      observer,
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});
